import { login, logout, refreshToken, sysConnect, getAuthInfo } from '@/api/basebasic'
import { getListMeunFuntionBymeunCode } from '@/api/security/menu'
import { getToken, setToken, removeToken, saveTokenExpire } from '@/utils/auth'
import { useImageUrl } from "@/utils/dynamic";
import { getUrlKey } from '@/utils/index'
import defaultSettings from '@/settings'
import defaultImgs from '@/images'
import cache from '@/plugins/cache'

const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    roles: [],
    permissions: [],
    subSystemList: [],
    activeSystemName: '',
    activeSystemIcon: '',
    activeSystemCode: '',
    menus: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
    SET_SUBSYSTEMLIST: (state, subSystemList) => {
      state.subSystemList = subSystemList
    },
    SET_ACTIVESYSTEMNAME: (state, activeSystemName) => {
      state.activeSystemName = activeSystemName
    },
    SET_ACTIVESYSTEMICON: (state, activeSystemIcon) => {
      state.activeSystemIcon = activeSystemIcon
    },
    SET_ACTIVESYSTEMCODE: (state, activeSystemCode) => {
      state.activeSystemCode = activeSystemCode
    },
    SET_MENUS: (state, menus) => {
      state.menus = menus
    }
  },

  actions: {
    // 登录:只存了token和过期时间2个值
    Login({ commit }, loginInfo) {
      const username = loginInfo.username.trim()
      const password = loginInfo.password
      const vcode = loginInfo.vcode
      const verifyCodeKey = loginInfo.verifyCodeKey

      return new Promise((resolve, reject) => {
        login({
          Username: username,
          Password: password,
          Vcode: vcode,
          Vkey: verifyCodeKey,
          AppId: loginInfo.appId,
          SystemCode: loginInfo.systemCode,
          Host: loginInfo.host
        })
          .then(response => {

            if (response.Success) {
              const data = response.ResData
              //1.存cookies
              setToken(data.AccessToken)
              saveTokenExpire(data.TokenExpiresIn)
              //2.存state
              commit('SET_TOKEN', data.AccessToken)
              //3.存Local              
              cache.local.set('login-encode', data.ActiveSystemEnCode)
            }
            resolve(response)
          }).catch(error => {
            reject(error)
          })
      })
    },

    // 获取用户信息
    async GetInfo({ dispatch }) {
      var syskey = getUrlKey('openmf')
      var isConnet = syskey !== null && syskey !== undefined && syskey !== '' && syskey !== 'null'
      if (isConnet) {
        var data = {
          openmf: syskey,
          appId: defaultSettings.appId,
          systemCode: defaultSettings.activeSystemCode
        }
        //获取旧的 login-encode
        var oldLoginCode = cache.local.get('login-encode')
        //console.log("oldLoginCode:" + oldLoginCode)
        //重设切换 login-encode
        const loginRes = await dispatch('sysConnetLogin', data)
        //获取最新 login-encode
        var newLoginCode = cache.local.get('login-encode')
        //console.log("newLoginCode:" + newLoginCode)
        //对比两个 login-encode
        if (oldLoginCode != newLoginCode) {
          console.log("第一次切换数据并重新发请求...")
          cache.session.remove('AUTHINFO');
        }
        else {
          //console.log("第二次加载已缓存的授权数据...")
        }
        //设置授权数据
        return await dispatch('SetAuthData')
      }
      else {
        //设置授权数据
        return await dispatch('SetAuthData')
      }
    },
    //设置授权数据
    async SetAuthData({ dispatch }) {
      const info = cache.session.get('AUTHINFO');
      if (info == null) {
        return new Promise((resolve, reject) => {
          getAuthInfo().then(res => {
            if (res && res.Success) {
              const data = res.ResData
              dispatch('SetUserInfo', data)
              //写入 Session，浏览器关闭需要重新加载一次因此用 session，不用 local
              cache.session.set('AUTHINFO', JSON.stringify(res));
            }
            resolve(res)
          }).catch(error => {
            reject(error)
          })
        })
      }
      else {
        const res = JSON.parse(info);
        if (res && res.Success) {
          const data = res.ResData
          dispatch('SetUserInfo', data)
          //测试输出
          // if (data.MenusRouter == null) {
          //   console.log("没有加载到菜单")
          // }
        }
        return res; // 返回缓存的数据
      }
    },
    // 设置用户信息
    SetUserInfo({ commit }, data) {
      const avatar = data.HeadIcon === null ? useImageUrl(defaultImgs.defaultAva) : useImageUrl(data.HeadIcon)
      //1.存state
      commit('SET_AVATAR', avatar)
      commit('SET_NAME', data.Account)
      commit('SET_ACTIVESYSTEMNAME', data.ActiveSystemName)
      commit('SET_ACTIVESYSTEMICON', data.ActiveSystemIcon)
      commit('SET_ACTIVESYSTEMCODE', data.ActiveSystemEnCode)
      commit('SET_ROLES', data.RoleData)
      commit('SET_SUBSYSTEMLIST', data.SubSystemList)
      commit('SET_MENUS', data.MenusRouter)
      commit('SET_PERMISSIONS', data.Modules)
      //2.存session     
      cache.session.set('layout-setting', data.UserTheme);
    },
    // 退出系统
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        }).finally(e => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_PERMISSIONS', [])
          cache.session.remove('AUTHINFO');
          cache.local.remove('login-encode');
          removeToken()
        })
      })
    },

    // 前端 退出系统
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        commit('SET_PERMISSIONS', [])
        cache.session.remove('AUTHINFO')
        cache.local.remove('login-encode')
        removeToken()
        resolve()
      })
    },
    // 刷新 token
    ResetToken({ commit }) {
      const param = {
        'token': getToken()
      }
      removeToken() // must remove  token  first
      return new Promise(resolve => {
        refreshToken(param).then(res => {
          const data = res.ResData
          setToken(data.AccessToken)
          commit('SET_TOKEN', data.AccessToken)
          saveTokenExpire(data.TokenExpiresIn)
        })
        commit('RESET_STATE')
        resolve()
      })
    },
    userNowMeunsFun(encode) {
      const code = encode
      return new Promise((resolve, reject) => {
        getListMeunFuntionBymeunCode({ enCode: code }).then(response => {
          const data = response.ResData
          cache.local.set('scm_currentmenus', JSON.stringify(data))
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 系统切换
    async sysConnetLogin({ commit }, data) {
      return new Promise((resolve, reject) => {
        sysConnect(data).then(response => {
          const data = response.ResData

          console.log("切换系统，重新赋值登录信息...")
          //切换成功后更新登录系统代码，目的为了第二次加载不再去请求接口
          cache.local.set('login-encode', data.ActiveSystemEnCode)
          commit('SET_TOKEN', data.AccessToken)
          setToken(data.AccessToken)

          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default user
